var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIc16SocialYoutube = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none",
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentcolor",
  fillRule: "evenodd",
  d: "M14.17 3.854c.216.215.371.483.45.777.459 1.843.353 4.753.01 6.667a1.743 1.743 0 0 1-1.227 1.226c-1.076.294-5.405.294-5.405.294s-4.328 0-5.404-.294a1.742 1.742 0 0 1-1.227-1.226C.907 9.463 1.033 6.55 1.36 4.64a1.742 1.742 0 0 1 1.226-1.227c1.076-.293 5.405-.302 5.405-.302s4.329 0 5.404.293c.294.08.562.235.777.45Zm-3.967 4.11-3.591 2.08v-4.16l3.59 2.08Z",
  clipRule: "evenodd"
})));
export default SvgIc16SocialYoutube;